// Helper subtext shown directly under the Verifone payment iframe wherever a
// card payment is taken — the booking checkout, the gift-voucher checkout, and
// the "Pay the difference" flow on the manage-booking page. Copy + styling only
// — no logic, no data. Styled to match the muted helper text already used on the
// checkout screen (small, soft, light weight) using design-system tokens, so it
// reads as quiet subtext rather than a loud banner.
export function PaymentInfoNote() {
  const lines = [
    <>
      Using autofill can sometimes cause a &ldquo;card not valid&rdquo; error. If that
      happens, simply retype the last few digits of your card number.
    </>,
    <>We don&apos;t accept American Express.</>,
  ];

  return (
    <ul className="flex flex-col gap-1.5 px-1 text-[12px] font-light leading-relaxed text-ink-soft">
      {lines.map((line, i) => (
        <li key={i} className="flex gap-2">
          <span aria-hidden className="select-none text-ink-soft/60">•</span>
          <span>{line}</span>
        </li>
      ))}
    </ul>
  );
}
